import React, { useState, useEffect, useRef } from 'react';

const ICONS = ['🎯', '🎨', '💼', '📊', '🚀', '💡', '🤝', '📈', '🌐', '💻', '📱', '✨', '🏆', '⚡', '🔧', '📝'];

const IconPicker = ({ value, onChange }) => {
    const [isOpen, setIsOpen] = useState(false);
    const containerRef = useRef(null);

    useEffect(() => {
        if (!isOpen) return;

        const handleKeyDown = (e) => {
            if (e.key === 'Escape') setIsOpen(false);
        };

        const handleClickOutside = (e) => {
            if (containerRef.current && !containerRef.current.contains(e.target)) {
                setIsOpen(false);
            }
        };

        document.addEventListener('keydown', handleKeyDown);
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('keydown', handleKeyDown);
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [isOpen]);

    return (
        <div className="icon-picker" ref={containerRef}>
            <button
                type="button"
                className="icon-display"
                onClick={() => setIsOpen(!isOpen)}
                title="Choose an icon"
                aria-haspopup="true"
                aria-expanded={isOpen}
            >
                {value || '🎯'}
            </button>

            {isOpen && (
                <div className="icon-dropdown" role="listbox">
                    {ICONS.map(icon => (
                        <button
                            key={icon}
                            type="button"
                            className="icon-option"
                            role="option"
                            onClick={() => {
                                onChange(icon);
                                setIsOpen(false);
                            }}
                        >
                            {icon}
                        </button>
                    ))}
                </div>
            )}
        </div>
    );
};

export default IconPicker;
